import React from 'react';
import { SliceWrapper } from './SliceWrapper';

interface IProps {
  isArticle: boolean;
  children: React.ReactNode;
  mergeTop?: boolean;
}

export const RichText = ({ isArticle, children, mergeTop }: IProps) => {
  return (
    <SliceWrapper left={children} isArticle={isArticle} mergeTop={mergeTop} />
  );
};
